import type { components } from "@/api-schema";
import { DataExportType } from "@/api-schema-enums";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { DATA_EXPORT_API_PATH, DATA_EXPORT_RESOURCE } from "./use-data-export-create.mutation";

export type DataExportColumn = components["schemas"]["DataExportColumnDto"];

export function useDataExportColumnsQuery(type: DataExportType, { enabled = true }: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: [DATA_EXPORT_RESOURCE, "columns", type],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<DataExportColumn[]>(`${DATA_EXPORT_API_PATH}/types/${type}/columns`);
      return response.data;
    },
    staleTime: Infinity,
    enabled,
  });
}
